import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchEmployeePlansInCurrentBoard(pointSystemIdParam = null) {
  let pointSystemId = pointSystemIdParam;

  if (!pointSystemId) {
    const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
    if (!pointSystem) {
      return;
    }
    pointSystemId = pointSystem.id;
  }

  yield put(actions.fetchEmployeePlans(pointSystemId));

  let items;
  try {
    ({ items } = yield call(request, api.getEmployeePlans, pointSystemId));
  } catch (error) {
    yield put(actions.fetchEmployeePlans.failure(pointSystemId, error));
    return;
  }

  yield put(actions.fetchEmployeePlans.success(pointSystemId, items));
}

export function* createEmployeePlanInCurrentBoard(data = {}) {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  yield put(actions.createEmployeePlan(pointSystem.id, data));

  let item;
  try {
    ({ item } = yield call(request, api.createEmployeePlan, pointSystem.id, data));
  } catch (error) {
    yield put(actions.createEmployeePlan.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.createEmployeePlan.success(item));
  yield call(fetchEmployeePlansInCurrentBoard);
}

export function* updateEmployeePlan(id, data) {
  yield put(actions.updateEmployeePlan(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateEmployeePlan, id, data));
  } catch (error) {
    yield put(actions.updateEmployeePlan.failure(id, error));
    return;
  }

  yield put(actions.updateEmployeePlan.success(item));
}

export function* deleteEmployeePlan(id) {
  yield put(actions.deleteEmployeePlan(id));

  let item;
  try {
    ({ item } = yield call(request, api.deleteEmployeePlan, id));
  } catch (error) {
    yield put(actions.deleteEmployeePlan.failure(id, error));
    return;
  }

  yield put(actions.deleteEmployeePlan.success(item));
  yield call(fetchEmployeePlansInCurrentBoard);
}

export default {
  fetchEmployeePlansInCurrentBoard,
  createEmployeePlanInCurrentBoard,
  updateEmployeePlan,
  deleteEmployeePlan,
};

